import { render, staticRenderFns } from "./receiveLimit.vue?vue&type=template&id=f5a99954&"
import script from "./receiveLimit.vue?vue&type=script&lang=js&"
export * from "./receiveLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports